angular.module('impactx.invoice').controller('InvoiceMatchCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    InvoiceMatchCtrl]);

function InvoiceMatchCtrl($scope, dataGen, $mdDialog, ToastService, TranslationService) {
    var ctrl = this;

    ctrl.buttonLabel = TranslationService.get('forward');

    function getData() {
        dataGen.postAsForm($scope, {blhId: ctrl.blhId, dnhIds: ctrl.dnhIds}, "/invoice/match/deliverynote").then(function () {
            ToastService.openStandardToast($scope.trns.matchSuccess);
        });
    }

    ctrl.close = function() {
        $mdDialog.hide();
    }

    getData();
}